import SampleReportView from "@/components/samples/SampleReportView";
import { ONYX_RENEWABLES_REPORT } from "@/data/sample-reports";

const OnyxRenewablesSample = () => <SampleReportView report={ONYX_RENEWABLES_REPORT} />;

export default OnyxRenewablesSample;
